<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">BUSQUEDA DE EMPRESAS</h5>
        <div class="col-12 col-md-12 row mt-4"> 
        <div class="col-12 col-md-3">
            <label>Empresas</label>
            <input
              type="text"
              class="form-control"
              placeholder="Nombre de empresa"
              v-model="parametro"
            />
          </div>  
          <div class="col-12 col-md-3">
                    
                      <label>Rubros:</label>
                      <select
                        class="form-control"
                        v-model="rubros"
                      >
                      <option value="" active>SELECCIONAR ETAPAS</option>
                        <option
                          v-for="(item, index) in resultadoRubro"
                          :key="index"
                          :value="item.id_rubro"
                          >{{ item.rubro_descripcion }}</option
                        >
                      </select>
                    
                  </div>   
          <div class="col-12 col-md-3">
                    <label>Departamentos:</label>
                    <select class="form-control" v-model="departamento">
                      <option value="" active>SELECCIONAR DEPARTAMENTO</option>
                      <option value="LPG">LA PAZ</option>
                      <option value="SCD">SANTA CRUZ</option>
                      <option value="CBD">COCHABAMBA</option>
                      <option value="ORD">ORURO</option>
                      <option value="TJD">TARIJA</option>
                      <option value="PTD">POTOSI</option>
                      <option value="CHD">CHUQUISACA</option>
                      <option value="BND">BENI</option>
                      <option value="PND">PANDO</option>
                    </select>
                  </div>
          <div
            class="col-12 col-md-3 "
            
          >
            <label><br> </label>
            <div class="form-group">
            
              <button
                class="btn btn-info"
                type="button"
                @click="
                  busquedaEmpresaBaja(
                    parametro,
                    departamento,
                    rubros
                  )
                "
              >
                Buscar
                <i class="fa fa-search"></i>
              </button>
              &nbsp;
              <button
                class="btn btn-secondary"
                type="button"
                @click="
                  limpiar()
                "
              >
                <i class="fa fa-refresh"></i>
              </button>
            </div>
          </div>
        </div>
          
        <div class="row">
          <div
            class="table-responsive mt-3"
            style="overflow-y:scroll; height:700px;"
          >
           
            <table class="table table-bordered">
              <tr class="text-center">
                <th><small class="font-weight-bold">#</small></th>
                <th><small class="font-weight-bold">EMPRESA</small></th>
                <th><small class="font-weight-bold"></small>REPRESENTANTE</th><th>
                  <small class="font-weight-bold">DIRECCIÓN</small></th>
                <th><small class="font-weight-bold">RUBRO</small></th>
                <th><small class="font-weight-bold">ESTADO</small></th>
                <th><small class="font-weight-bold">ACCIONES</small></th>
              </tr>
              <tr v-for="(item, index) in registrosEncontrados" :key="index">
                <td class="text-center">
                  <small>{{ index + 1 }}</small>
                </td>
                <td>
                  <small>{{ item.emp_razon_social }}</small><br>
                  <small>NIT:{{ item.emp_nit }}</small>
                </td>
                <td class="text-center">
                  <small>{{ item.nombre_completo }}</small> <br />
                   <small> Documento:{{ item.per_numero_documento }}
                    
                  </small>
                </td>
                <td class="text-center">
                  <small>{{
                    item.emp_direccion
                  }}</small><br>
                  <small>Departamento:{{ item.emp_departamento }}</small>
                </td>
                <td>
                  <small>{{ item.rubro_descripcion }}</small>
                </td>
                
                <td class="text-center">
                  <span v-if="item.estado_registro==1" class="badge badge-success"> ACTIVO</span>
                  <span v-else class=" badge badge-danger">INACTIVO</span>
                </td>
                <td>
                  <span
                        
                              class="btn btn-outline-danger btn-sm mr-2"
                              title="Sanción"
                              @click="showModal(item)"
                            >
                              <i class="fa fa-trash"></i>
                            </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      class="modal fade"
      title="DAR DE BAJA"
      size="xs"
      hide-footer
      ref="modal"
      :no-close-on-backdrop="true"
    >
      <div class="container">
        <div class="row">
          
          <div class="col-12">
            <div class="form-group">
              
              <span>Desea dar de baja a la empresa <b>{{datosEmpresa.emp_razon_social}}</b></span>
                <label class=" mr-1">Motivo</label>
                <!-- <pre>{{datosEmpresa}}</pre> -->
                <input
                  type="text"
                  class="form-control"
                  v-model="observacion"
                  placeholder="Ej: Por Motivo de Incumplimiento"
                  @keyup="
                    observacion = observacion.toUpperCase()
                  "
                />
             
            </div>
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-9 float-right">
            <a @click="hideModal" class="btn btn-secondary mr-4"
              >Cerrar</a
            >
            <a 
              @click="bajaEmpresa(datosEmpresa)" class="btn btn-danger">
              Aceptar
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
//import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "buscarEmpresaDarBaja",
  components: {
    Loading,
  },
  data() {
    return {
      parametro: '',
      departamento: '',
      rubros: '',
      observacion: '',
      registrosEncontrados: [],
      resultadoRubro: [],
      datosEmpresa: [],
      cargando: false,
    };
  },
  methods: {
    showModal(item) {
    console.log(item);
      this.datosEmpresa = item;
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },
    async getListadoEmpresa() {
      let config = { headers: { token: this.token } };
      try {
        let resultados = await this.axios.get(`/ListaEmpresaBaja`, config);
        this.registrosEncontrados = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async busquedaEmpresaBaja(parametro, departamento, rubros) 
    { 
      if (parametro == null || parametro == '') {
        parametro = "0";
      }
      if (departamento == null || departamento == '') {
        departamento = "0";
      }
      if (rubros == null || rubros == '') {
        rubros = "0";
      }
        try {
          let resultados = await this.axios.get(
            `/BusquedaEmpresaBaja/${parametro}/${departamento}/${rubros}`
          );
          this.registrosEncontrados = resultados.data.contenido;
        } catch (error) {
          console.log("catch: ", error);
          this.$swal({
            title: "Información",
            text: "Ocurrio un Error al realizar la consulta!",
            type: "error",
            confirmButtonText: "Aceptar",
          });
        }
    },
    async limpiar() {
      this.parametro = ''; 
      this.departamento ='';
      this.rubros ='';
      
    //console.log(this.getListadoEmpresa());
      
    },
    async bajaEmpresa(item){
      
       try {
      let data = {
        id_empresa:item.id_empresa,
        id_persona:item.id_persona,
        //emp_razon_social:item.emp_razon_social,
        observacion: this.observacion
      };
      let res = await this.axios.put(`/bajaUsuarioEmpresa`, data);
        if (res.status === 200) {
          this.$swal({
            title: "Información",
            html:
              "Fue dado de baja la <b>Empresa</b>.",
            type: "success",
            confirmButtonText: "Aceptar",
          });
          this.hideModal();
           this.busquedaEmpresaBaja(item);
          //this.$router.push("historialDeclaracion");
        }
      } catch (error) {
        this.cargando = false;
        console.log(error);
        this.$swal({
          html: "No existen coincidencias",
          type: "info",
          confirmButtonText: "Aceptar",
        });
      }
    },

    async listaRubros() {
      let config = { headers: { token: this.token } };
      try {
        let resultados = await this.axios.get(`/listarRubros`, config);
        this.resultadoRubro = resultados.data.contenido;
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
  },
  created() {
  //this.getListadoEmpresa();
  this.listaRubros();
  },

};
</script>
